import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { TiposMenuEnum } from '@appNeo/core/helpers/enums/tiposMenuEnum';
import { IMenu } from '@appNeo/core/interfaces/IMenu';
import { BYPASS_FRONT_TOKEN } from '@appNeo/neoCore/interceptors/jwt/jwt.interceptor';
import { LOADER_TRANSPARENT } from '@appNeo/neoCore/interceptors/loaderInterceptor/loader.interceptor';
import { TipoPaginadorEnum } from '@appNeo/neoShared/helpers/enums/TipoPaginador.enum';
import { IRespApi } from '@appNeo/neoShared/helpers/interfaces/IResp-api';
import { Paginator } from '@appNeo/neoShared/models/paginator/paginator';
import { AuxiliarService } from '@appNeo/neoShared/services/auxiliar/auxiliar.service';
import { environment } from '@environments/environment';
import { BehaviorSubject, catchError, forkJoin, map, Observable, of, Subject, tap, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MenusService {

  public editando$ = new BehaviorSubject<boolean>(false);

  // solución para contextualizar endpoint area cliente y envio uso token front
  contextFront = { context: new HttpContext().set(BYPASS_FRONT_TOKEN, true) };s
  contextLoaderTransparent = { context: new HttpContext().set(LOADER_TRANSPARENT, true) };
  urlEntidad = environment.api_base_url_backoffice + '/menus';


  public error422Api$: Subject<IRespApi> = new Subject<IRespApi>();
  public menu$: BehaviorSubject<IMenu> = new BehaviorSubject<IMenu>(null);
  public menus$: BehaviorSubject<IMenu[]> = new BehaviorSubject<IMenu[]>(null);
  public totalMenus$: BehaviorSubject<number> = new BehaviorSubject<number>(null);

  constructor(
    private http: HttpClient,
    private auxiliar: AuxiliarService
  ) {
  }

  set menu(menu: IMenu) {
    if ( menu ) {
      // this.entidadesRelacionadas( menu ).subscribe( response => {
        let menuMapeada = { ...menu};
        this.menu$.next(menuMapeada);
      // })
    }

  }

  set editando(flag: boolean) {
    this.editando$.next(flag);
  }

  getAll(tipoPaginador?: TipoPaginadorEnum, paginator?: Paginator, filtros?: any): Observable<IMenu[]> {
    // return new Observable<any>( observer => {
    //   this.totalMenus$.next( MENUS.length );
    //   this.menus$.next( this.mapearEntidades(MENUS) );
    //   observer.next(this.mapearEntidades(MENUS));
    //   observer.complete();
    // });
    let request = (tipoPaginador === TipoPaginadorEnum.offline)
    ? this.urlEntidad
    : `${this.urlEntidad}?${this.auxiliar.extraerFiltrosPaginacion(paginator)}${this.auxiliar.extraerFiltros(filtros)}`;
    return this.http.get(request, { ... this.contextLoaderTransparent }).pipe(
        tap( (data: IRespApi )=> this.totalMenus$.next( data.total )),
        tap( (data: IRespApi )=> this.menus$.next( this.mapearEntidades(data.data) )),
        map( (data: IRespApi) => this.mapearEntidades(data.data)),
        catchError((err: IRespApi) => {
          return this.handleError(err, 'IRequestGetAllMenus');
        })
      );
  }

  get(id): Observable<IMenu>{
    return this.http.get(`${this.urlEntidad}/${id}`).pipe(
      map(  (data: IRespApi) =>  this.mapearEntidad(data['data']) ),
      catchError((err: IRespApi) => {
        return this.handleError(err, 'IRequestGetMenu');
      })
    );
  }

  getByTipoMenu(idTipoMenu: TiposMenuEnum): Observable<IMenu>{
    return this.http.get(`${this.urlEntidad}/?idTipoMenu=${idTipoMenu}`,  {...this.contextFront}).pipe(
      map((data: IRespApi) => data['data']),
      catchError((err: IRespApi) => {
        return this.handleError(err, 'IRequestGetMenusByTipo');
      })
    );
  }

  mapearEntidades( menus: IMenu[] ) {
    if (menus.length) {
      menus.forEach((element, index )=> {
        menus[index] = this.mapearEntidad( element );
      });
    }
    return menus;
  }

  mapearEntidad( entidad: IMenu ):IMenu{
     // let fechaFormatt = new Date(item?.fecha);
    // let fechaFormatt = this.datepipe.transform(item?.fecha, 'dd/MM/yyyy');
    // let importeFormatt = item.importe.toFixed(2);
    let item = Object.assign({}, entidad);
    if (item?.activo) {
      item.activo = this.auxiliar.getBoolean(item.activo);
      item.identificador = (item.identificador) ? item.identificador : item.id;
    }
    let camposTraduccion = {};
    if(item?.idiomas) {
      camposTraduccion = this.auxiliar.obtenerContenidoPorIdioma(item.idiomas);
    }
    let _item = {...item, ...camposTraduccion};
    return _item;
  }

  create(request: any): Observable<any>{
    return this.http.post<IRespApi>( `${this.urlEntidad}`, request) .pipe(
      map( (resp: IRespApi) => resp.data),
      catchError( (err: IRespApi) => {
        return this.handleError( err,  'IRequestPostMenu');
      })
    );
  }

  update(id: string, request: any) {
    return this.http.put( `${this.urlEntidad}/${id}`, request ).pipe(
      map((data: IRespApi) => data['data']),
      catchError( (err: IRespApi) => {
        return this.handleError( err,  'IRequestPutMenu');
      })
    );
  }

  delete(id:string) {
    return this.http.delete( `${this.urlEntidad}/${id}` ).pipe(
      map((valor: string) => this.auxiliar.getBoolean(valor)),
      catchError( (err: IRespApi) => {
        return this.handleError( err,  'IRequestDeleteMenu');
      })
    );
  }
  asignarExtrasMenu(id: string, request: any) {
    return this.http.post<IRespApi>( `${this.urlEntidad}/${id}/asignarExtras`, request ) .pipe(
      map( (resp: IRespApi) => resp.data),
      catchError( (err: IRespApi) => {
        return this.handleError( err,  'IRequestPostExtrasMenu');
      })
    );
  }

  vaciarExtrasMenu(id: string) {
    return this.http.post<IRespApi>( `${this.urlEntidad}/${id}/eliminarExtras`, {}) .pipe(
      map( (resp: IRespApi) => resp.data),
      catchError( (err: IRespApi) => {
        return this.handleError( err,  'IRequestPostVaciarMenu');
      })
    );
  }

  // Turnos
  getTurnosAsociados(id): Observable<object[]> {
    return this.http.get(`${this.urlEntidad}/${id}/turnos`, { ...this.contextLoaderTransparent }).pipe(
      map((data: IRespApi) => this.mapearTurnosAsociados(data.data)),
      catchError((err: IRespApi) => {
        return this.handleError(err, 'IRequestGetMenu');
      })
    );
  }

  mapearTurnosAsociados(turnos): object[] {
    // console.log('Recibimos turnos', turnos);
    let idTurnosAsociados: object[] = [];
    if (turnos.length) {
      turnos.forEach((element, index) => {
        if (element['id']) {
          let camposTraduccion = {};
          if (element?.idiomas) {
            camposTraduccion = this.auxiliar.obtenerContenidoPorIdioma(element.idiomas);
          }
          idTurnosAsociados.push({ ...element, ...camposTraduccion, asociado: true });
        }
      });
      return idTurnosAsociados;
    }
  }


  asignarTurnosMenu(id: string, request: any) {
    return this.http.post<IRespApi>(`${this.urlEntidad}/${id}/asignarTurnos`, request).pipe(
      map((resp: IRespApi) => resp.data),
      catchError((err: IRespApi) => {
        return this.handleError(err, 'IRequestPostTurnosMenu');
      })
    );
  }

  vaciarTurnosMenu(idPaquete: string) {
    return this.http.post<IRespApi>(`${this.urlEntidad}/${idPaquete}/eliminarTurnos`, {}).pipe(
      map((resp: IRespApi) => resp.data),
      catchError((err: IRespApi) => {
        return this.handleError(err, 'IRequestPostVaciarTurnosMenu');
      })
    );
  }
  /************************************
  * Funciones apoyo                  *
  *************************************/
   resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    let peticionEntidades = this.getAll().pipe(
      catchError(err => of(err))
    );
    const id = route.params.id;
    if (id) {
      let peticionEntidad = this.get(id).pipe(
        catchError(err => of(err))
      );
      return forkJoin([peticionEntidades, peticionEntidad]);
    } else {
      return forkJoin([peticionEntidades]);
    }
  }

  private handleError(err: IRespApi, idRequest = '') {
    // control error server con un html ok
    if (err == 'OK') {
      let mensaje = environment.errorServidorSinCodigo;
      return throwError({ 'error': true, 'data': mensaje, mensaje, 'err': err });
    }
    // dialog específico
    if ( err.codigoError === 422) {
      err.request = idRequest;
      this.error422Api$.next(err);
    }

    // pantalla común
    let mensaje = err?.mensaje;
    if ( err.codigoError === 403) {
      mensaje = `${ err.mensaje }: `;
      err.data.forEach(element => {
        mensaje += element.mensaje;
      });
    }
    if (err.codigoError === 404) {
      let avisos = '';
      if ( err.data ) {
        if ( typeof err.data === 'string') {
          avisos = err.data;
        }else {
          err.data.forEach(element => {
            if ( element.id === 999 ) {
              avisos = ' ' + element.mensaje + ' ';
            }
          });
        }
      }
      mensaje = err?.mensaje +  avisos;
    }
    return throwError({'error' : true, 'data': err.data, mensaje });
  }
}
